import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import SEO from "../../UI/SEO/SEO";
import PrimarySidebarLayout from "../../Layout/PrimarySidebarLayout";
import SuccessScoreService from "../../../Services/SuccessScore.service";
import useHasPermission from "../../Hooks/useHasPermission";
import MessageRoutes, { getMessageInboxPath, getMessageSchedulePath, getMessageSentPath, getMessageTemplatePath, } from "./MessageRoutes/MessageRoutes";
const MessageLayout = () => {
    /**
     * Making sure the user can see Course success score and term success score
     * */
    const [canSeeCourseSuccessScore, setCanSeeCourseSuccessScore] = useState(false);
    const [canSeeTermSuccessScore, setCanSeeTermSuccessScore] = useState(false);
    // PERMISSION TO CREATE SCHEDULED MESSAGES
    const canCreateTasks = useHasPermission("CAN_CREATE_SCHEDULED_MESSAGES");
    const menuItem = [
        {
            to: getMessageInboxPath(),
            title: "Inbox",
            icon: "inbox",
        },
        {
            to: getMessageSentPath(),
            title: "Sent",
            icon: "paper-plane",
        },
    ];
    // Show only if user have permission
    if (canCreateTasks) {
        menuItem.push({
            to: getMessageSchedulePath(),
            title: "Scheduled Messages",
            icon: "clock",
        });
    }
    menuItem.push({
        to: getMessageTemplatePath(),
        title: "Templates",
        icon: "folders",
    });
    useEffect(() => {
        SuccessScoreService.canCurrentUserSeeCourseRisk().then(setCanSeeCourseSuccessScore);
        SuccessScoreService.canCurrentUserSeePersistenceRisk().then(setCanSeeTermSuccessScore);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(SEO, { title: "Messages" }), _jsx(PrimarySidebarLayout, { title: "Messages", menu: menuItem, sidebarSize: "sm", children: () => (_jsx(MessageRoutes, { hasPermissionForTermSuccessScore: canSeeTermSuccessScore, hasPermissionForCourseSuccessScore: canSeeCourseSuccessScore })) })] }));
};
export default MessageLayout;
